import { render, staticRenderFns } from "./ptUserProtocol.vue?vue&type=template&id=24b418d9&scoped=true&"
import script from "./ptUserProtocol.vue?vue&type=script&lang=js&"
export * from "./ptUserProtocol.vue?vue&type=script&lang=js&"
import style0 from "./ptUserProtocol.vue?vue&type=style&index=0&id=24b418d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b418d9",
  null
  
)

export default component.exports